import { IconName } from '@infotech-soe/erp-ui-kit';
import { CommandHotKey, THotKey } from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../infrastructure/providers/abstract/IApiProvider';
import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import { DocLinksMode } from '../../../models/docLinks/docLinks';
import { ClientContext } from '../../context/IContextService';
import { CommandName } from '../CommandViewModel';

import CategoryCommand, { RefreshStrategy } from './CategoryCommand';

class CreateRecordCommand extends CategoryCommand<TActionArgsValues> {
  public static COMMAND_NAME = 'create' as const;

  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.CREATE,
    };
  }

  public getIcon(): IconName {
    return 'create';
  }

  public getHotKey(): THotKey {
    return CommandHotKey.CreateRecord;
  }

  public getName(): CommandName {
    return CreateRecordCommand.COMMAND_NAME;
  }

  public isAvailable(context: ClientContext): boolean {
    if (!super.isAvailable(context)) {
      return false;
    }

    if (context.has('ParentCategory')) {
      return Boolean(context.get('Parent'));
    } else if (
      context.get('InParams')?.linksGraph?.mode === DocLinksMode.SINGLE
    ) {
      return false;
    }

    if (context.has('TreeNode') && context.get('TreeNode')) {
      return context.get('TreeNode').hasAccess;
    }

    return true;
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.NEW;
  }
}

export default CreateRecordCommand;
